/**
 * @param value
 * @returns
 */
export const isObject = (value: unknown) => typeof value === 'object' && value !== null;

/**
 * @param obj
 * @returns
 */
export const isEmptyObject = (obj: Record<string, unknown>) => Object.keys(obj).length === 0;
